import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rectangular-prism-calculator',
  component: () => import('../../routes/RectangularPrismCalculator.svelte'),
  card: {
    id: 'rectangular-prism-calculator',
    title: 'Rectangular Prism Calculator',
    description: 'Calculate the volume, surface area, diagonal, and more of a rectangular box (rectangular prism) from length, width, and height.',
    icon: 'view_in_ar',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/rectangular-prism-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Rectangular Prism Calculator – Volume, Surface Area & Diagonal',
    description:
      'Free rectangular prism calculator to find volume, total surface area, lateral surface area, base area, and space diagonal from length, width, and height. Includes formulas and step-by-step results.',
  },
};

export default meta;